import { PayPalButtonProps } from '@msc-b2c/interfaces/types';
import PaymentSubmit from '../paymentbox/components/PaymentSubmit/PaymentSubmit';
import { closeLoader, isElementVisible, openLoader, RootState } from '@msc-b2c/shared-utils';
import { useEffect, useState } from 'react';
import { usePaypal } from './hooks/usePayPal';
import { useSelector } from 'react-redux';

const PayPalButton = ({
  merchantIdBooking,
  datatransPayPalUrl,
  termsLabel,
  transactionId,
  amount,
  paymentType,
}: PayPalButtonProps) => {
  const [areTermsAgreed, setAreTermsAgreed] = useState(false);
  const userEmailInput = useSelector((state: RootState) => state.myAreaCart?.loggedUserEmailInput);

  const { payPal, paymentLoading } = usePaypal({
    merchantIdBooking,
    datatransPayPalUrl,
    transactionId,
    amount,
    paymentType,
  });

  useEffect(() => {
    paymentLoading ? openLoader('.loader') : closeLoader('.loader');
  }, [paymentLoading]);

  const handleTermsClick = () => setAreTermsAgreed((prevTermsState) => !prevTermsState);

  return !paymentLoading ? (
    <PaymentSubmit
      id={'paypalBtn-' + paymentType}
      terms={termsLabel}
      onCheck={handleTermsClick}
      checked={areTermsAgreed}
    >
      <div
        ref={payPal}
        className={
          !areTermsAgreed ||
          (!userEmailInput && isElementVisible('.cmp-sidesummary__email-section'))
            ? 'disabled paypal-btn-container'
            : 'paypal-btn-container'
        }
      />
    </PaymentSubmit>
  ) : null;
};

export default PayPalButton;
